import { determinePageType, getAppType } from '~/modules/analytics/gtmEventTypes/gtmEventTypeHelper';
import { GA4PageLevelEvent, GtmEventType } from './gtmEventType';

export class GtmPageLevelType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === 'authentication';
    }

    // @ts-expect-error * Automated Type Error Fix
    getBody(event): GA4PageLevelEvent {
        const body: GA4PageLevelEvent = {
            locale: event.locale,
            login_status: event.authenticated ? 'logged in' : 'not logged in',
            page_path: window.location.origin + window.location.pathname,
            page_path_with_query: window.location.href,
            page_referrer: event.referrer,
            referring_hostname: event.referrer ? new URL(event.referrer).hostname : '',
            tbid_company: event.company,
            tbid_org_id: event.orgId,
            tbid_relationship: event.relationship,
            tbid_role: event.role,
            user_id: event.id,
        };

        if (determinePageType(event.url) === 'Listing') {
            body.listing_url = event.url;
            body.listing_id = new URL(event.url)?.searchParams?.get('listingId') || '';
            if (event.listingRecordType) {
                body.app_type = getAppType(event.listingRecordType);
            }
        }
        return body;
    }

    getLoginFields(authenticated: boolean) {
        const loginStatus = authenticated ? 'logged in' : 'not logged in';
        const userState = authenticated ? 'known account' : 'guest';
        return {
            loginStatus,
            userState,
        };
    }
}
